/** Matches MUI `theme.breakpoints.down('sm')` — used before theme/hooks are ready. */
export function isMobileViewport(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.matchMedia('(max-width: 599.95px)').matches;
}
